import React from 'react'
import './SingleAvocado.scss'

/**
 * Single Avocado is flexible and takes various sizes
 * outerSize
 * seedSize adjusts the seed radius by a percentage
 * leafSize
 * stemSize
 * @param {*} props
 */
const SingleAvocado = ({ seedSize, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 100 100"
      id="avocado"
      height={height ? `${height}` : '200'}
      width={height ? `${height}` : '200'}
      fill="currentColor"
      style={{ overflow: 'visible' }}
      filter="url(#shadow)"
    >
      <defs>
        <filter id="shadow" x="0" y="0" width="200%" height="200%">
          <feOffset result="offOut" in="SourceGraphic" dx="3" dy="17" />
          <feColorMatrix
            result="matrixOut"
            in="offOut"
            type="matrix"
            values="0.36 0 0 0 0 0 0.36 0 0 0 0 0 0.36 0 0 0 0 0 1 0"
          />
          <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="10" />
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
      </defs>
      <g id="avocado-main">
        <g id="avocado-leaf">
          <path
            d="m 58.07,29.32 c -5.11,0 -9.01,-1.09 -9.29,-1.17 l -2.32,-0.67 0.59,-2.34 C 47.18,24.61 50.4,12.13 60.32,6.4 70.24,0.67 82.66,4.13 83.18,4.28 l 2.32,0.67 -0.6,2.34 c -0.13,0.53 -3.35,13.01 -13.27,18.74 -4.45,2.57 -9.4,3.29 -13.56,3.29 z"
            id="leaf-outer"
            fill="#7db208"
          />
          <path
            d="m 52.71,23.87 c 3.71,0.6 10.75,1.1 16.42,-2.17 5.7,-3.29 8.77,-9.63 10.1,-13.14 -3.71,-0.6 -10.75,-1.1 -16.43,2.17 -5.67,3.28 -8.75,9.63 -10.09,13.14 z"
            id="leaf-inner"
            fill="#bcdd7a"
          />
        </g>
        <path
          d="m 46.95,96.89 c -14.3,0 -25.93,-11.63 -25.93,-25.93 0,-5.76 2.3,-10.65 4.52,-15.38 2.26,-4.82 4.4,-9.38 4.4,-14.95 0,-9.38 7.63,-17.01 17.01,-17.01 9.38,0 17.01,7.63 17.01,17.01 0,5.57 2.14,10.12 4.4,14.95 2.22,4.73 4.52,9.62 4.52,15.38 0,14.29 -11.63,25.93 -25.93,25.93 z"
          id="avocado-outer"
          fill="#93b93a"
        />
        <path
          d="m 46.95,28.62 c -6.62,0 -12.01,5.39 -12.01,12.01 0,6.68 -2.48,11.97 -4.88,17.07 -2.08,4.43 -4.04,8.61 -4.04,13.25 0,11.54 9.39,20.93 20.93,20.93 11.54,0 20.93,-9.39 20.93,-20.93 0,-4.65 -1.96,-8.83 -4.04,-13.25 C 61.44,52.59 58.96,47.31 58.96,40.63 58.96,34 53.57,28.62 46.95,28.62 Z"
          id="avocado-inner"
          fill="#d8d881"
        />
        <g id="avocado-seed">
          <circle
            cx="46.98"
            cy="71.980003"
            r={seedSize > 0 ? (seedSize * 11.71).toString() : '11.71'}
            id="circle4489"
            fill="#704012"
          />
        </g>
        <g id="avocado-stem">
          <path
            d="m 46.99,26.81 v 0 c -1.15,0 -2.09,-0.94 -2.09,-2.09 v -5.85 c 0,-1.15 0.94,-2.09 2.09,-2.09 v 0 c 1.15,0 2.09,0.94 2.09,2.09 v 5.85 c 0,1.15 -0.94,2.09 -2.09,2.09 z"
            id="stem"
            fill="#93b93a"
          />
        </g>
      </g>
    </svg>
  )
}

export default SingleAvocado



// WEBPACK FOOTER //
// ./src/components/viz/SingleAvocado.js